module.exports = __webpack_public_path__ + "img/activities-gala.007a1f1b.jpg";